/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { IconX } from '@tabler/icons-react';
import styles from './custom-modal.module.css';

type CustomModalProps = {
  show: boolean;
  title?: string | React.ReactNode;
  centeredTitle?: 'left' | 'center';
  width?: number | string;
  onClose: () => any;
  children?: React.ReactNode;
  outsideClickClose?: boolean;
  showCloseIcon?: boolean;
  style?: string | any;
  subtitle?: string;
  modalBackdrop?: 'light' | string;
  showDivider?: boolean;
  bodyStyle?: string | any;
  bgPadding?: boolean;
  topCross?: boolean;
  userPill?: {
    initials: string;
    name: string;
  };
  footer?: React.ReactNode;
  bodyClassName?: string;
};

export default function CustomModal({
  show,
  title,
  centeredTitle,
  width,
  onClose,
  children,
  outsideClickClose = true,
  showCloseIcon = false,
  style,
  subtitle,
  modalBackdrop = 'light',
  showDivider = false,
  bodyStyle,
  bgPadding = false,
  topCross = false,
  userPill,
  footer,
  bodyClassName = '',
}: CustomModalProps) {
  const modalRef: any = useRef();

  const handleOutsideClick = (e: any) => {
    if (!modalRef.current?.contains(e.target)) {
      if (outsideClickClose && show && onClose) {
        onClose();
      }
    }
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {show &&
        createPortal(
          <div
            style={bgPadding ? { padding: '0' } : {}}
            className={`${styles.modalBg} ${modalBackdrop === 'light' ? styles.modalBgLight : styles.modalBgDark}`}
            onClick={handleOutsideClick}
          >
            <div
              className={styles.modalContainer}
              style={{
                width: width ? `min(${typeof width === 'number' ? `${width}px` : width}, 90vw)` : undefined,
                ...style,
              }}
              ref={modalRef}
            >
              {/* title */}
              <div className={styles.modalHeaderSection}>
                <div className={styles.modalHeaderContent}>
                  {title && (
                    <h2 className={styles.modalTitle} style={{ textAlign: centeredTitle ? 'center' : 'left' }}>
                      {title}
                    </h2>
                  )}
                  {subtitle && (
                    <p className={styles.modalSubtitle} style={{ textAlign: centeredTitle ? 'center' : 'left' }}>
                      {subtitle}
                    </p>
                  )}
                  {userPill && (
                    <div className={styles.userPill}>
                      {userPill.initials && <div className={styles.userInitials}>{userPill.initials}</div>}
                      {userPill.name && <span className={styles.userName}>{userPill.name}</span>}
                    </div>
                  )}
                </div>

                {/* close button */}
                {showCloseIcon && (
                  <button className={styles.closeModalBtn} onClick={onClose} type="button">
                    <IconX />
                  </button>
                )}
                {topCross && (
                  <button className={styles.topCloseModalBtn} onClick={onClose} type="button">
                    <IconX width={16} height={16} />
                  </button>
                )}
              </div>
              {showDivider && <div className={styles.divider} />}
              <div className={`${styles.modalBodySection} ${bodyClassName}`} style={bodyStyle}>
                {/* body of modal */}
                {children}
              </div>
              {footer && <div className={styles.modalFooterSection}>{footer}</div>}
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
